import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'BLOCK_UPDATE',
    smsDelete : 'BLOCK_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        block: [],

        submitSuccess: false,
        blockLoading: false,
        blockError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_BLOCK(state, block) {
            state.block = block;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        BLOCK_LOADING (state, loading) {
            state.blockLoading = loading;
        },

        BLOCK_ERROR (state, hasError) {
            state.blockError = hasError;
        }
    },

    actions: {
        async addBlock ({commit, dispatch}, payload) {
            commit('BLOCK_LOADING', true);
            commit('BLOCK_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_block, payload.block, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchBlock')
                return response

            } catch (e) {
                commit('BLOCK_ERROR', true);
            } finally {
                commit('BLOCK_LOADING', false);
            }
        },

        async fetchBlock ({ commit }) {
            commit('BLOCK_LOADING', true);
            commit('BLOCK_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.block_list, config);
                let response = result.data
                commit('SET_BLOCK', response.data);

            } catch(error) {
                commit('BLOCK_ERROR', true);
            } finally {
                commit('BLOCK_LOADING', false);
            }
        },

        async getBlocksByCamp ({ commit }, payload) {
            commit('BLOCK_LOADING', true);
            commit('BLOCK_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.block_list_by_camp + payload, config);
                let response = result.data
                commit('SET_BLOCK', response.data);

            } catch(error) {
                commit('BLOCK_ERROR', true);
            } finally {
                commit('BLOCK_LOADING', false);
            }
        },

        async updateBlock ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_block + payload.id, payload.block, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchBlock')
                return response

            } catch (e) {
                commit('BLOCK_ERROR', true);
            } finally {
                commit('BLOCK_LOADING', false);
            }
        },
        
        async deleteBlock({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.block_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchBlock')
            return response
        }
    },

    getters: {}
}
